import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { call, getContext, put, select, takeEvery } from "redux-saga/effects"
import { put as putRequest } from "api"
import { Creators as modelCreators } from "model/data"
import { Creators as HistoryCreators } from "../../../actions/app/history"
import { get } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/accountTerms/", {
  acceptTermsAndConditions: {
    props: ["accountAlias"],
    track: true,
    trackType: "account-terms-and-conditions",
    trackPayload: ({ accountAlias }) => ({ account: accountAlias }),
  },
  toggleError: [],
})

const DEFAULT_STATE = {
  hasError: false,
}

function handleToggleError(state) {
  return { ...state, hasError: true }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE_ERROR]: handleToggleError,
})

function* acceptTermsAndConditions({ accountAlias }) {
  const { termsId, selectedAccount, accountId } = yield select(state => ({
    termsId: get(state, "global.data.accountTerms.data.id"),
    selectedAccount: get(state, "global.selected.accountMeta"),
    accountId: get(state, "global.selected.accountId"),
  }))

  try {
    const { needSignTerms } = yield call(putRequest, `/api/${accountAlias}/terms`, { termsId }, true)
    if (needSignTerms) {
      yield put(modelCreators.resetCollections(["accountTerms"]))
    } else {
      yield put(HistoryCreators.selectAccount({ ...selectedAccount, id: accountId, needSignTerms }))

      const { navigate } = yield getContext("router")
      yield call(navigate, `/${accountAlias}/home/resources`, { replace: true })
    }
  } catch {
    yield put(Creators.toggleError())
  }
}

export function* saga() {
  yield takeEvery(Types.ACCEPT_TERMS_AND_CONDITIONS, acceptTermsAndConditions)
}
